import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ContainerScrollModule } from '@app/components/container-scroll/container-scroll.module';
import { IconsModule } from '@app/components/icons/icons.module';
import { SharedModule } from '@app/shared/shared.module';

import { FeedbackRoutingModule } from './feedback-routing.module';
import { FeedbackComponent } from './feedback.component';
import { SendFeedbackComponent } from './send-feedback/send-feedback.component';
import {
  DialogPhoneNumberSupportScoreComponent
} from "@app/app/feedback/dialog-phone-number-support/dialog-phone-number-support.component";
import {DialogModule} from "@app/components/dialog/dialog.module";
import { GoftinoComponent } from './goftino/goftino.component';

@NgModule({
  declarations: [
    FeedbackComponent,
    SendFeedbackComponent,
    DialogPhoneNumberSupportScoreComponent,
    GoftinoComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReactiveFormsModule,
    IconsModule,
    FeedbackRoutingModule,
    ContainerScrollModule,
    DialogModule,
  ],
  entryComponents: [ ]
})
export class FeedbackModule { }
